import { AppTheme } from '@meitu/saas-ui/es/theme';
import { getLocaleStore } from '@/i18n';
import { IEnhanceSlider } from '../types';

export const getSliderConfig = (theme = AppTheme.white) => {
    const { $t } = getLocaleStore();
    return [
        {
            featureType: 'color',
            name: $t((v) => v.mainLayer.enhance.config.temperature),
            keyName: 'temperature',
            maxVal: 100,
            minVal: -100,
            lightBackgroundClass: 'sw_1',
            lightWrapBackgroundClass: 'sw_2',
            darkBackgroundClass: 'sw_1',
            darkWrapBackgroundClass: 'sw_2',
        },
        {
            featureType: 'color',
            name: $t((v) => v.mainLayer.enhance.config.tinge),
            keyName: 'tinge',
            maxVal: 100,
            minVal: -100,
            lightBackgroundClass: 'sd_1',
            lightWrapBackgroundClass: 'sd_2',
            darkBackgroundClass: 'sd_1',
            darkWrapBackgroundClass: 'sd_2',
        },
    ].map((item: IEnhanceSlider) => {
        theme = theme === AppTheme.dark ? AppTheme.dark : AppTheme.white;
        item.background =
            theme == 'dark'
                ? item.darkBackgroundClass
                    ? { useStyle: true, classname: item.darkBackgroundClass }
                    : item.darkBackgroundImage
                : item.lightBackgroundClass
                  ? { useStyle: true, classname: item.lightBackgroundClass }
                  : item.lightBackgroundImage;

        //蒙版背景
        item.wrapBackground =
            theme == 'dark'
                ? item.darkWrapBackgroundClass
                    ? { useStyle: true, classname: item.darkWrapBackgroundClass }
                    : item.darkWrapBackgroundImage
                : item.lightWrapBackgroundClass
                  ? { useStyle: true, classname: item.lightWrapBackgroundClass }
                  : item.lightWrapBackgroundImage;
        return item;
    });
};
